// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay[data-v-7fc5609c]{background:linear-gradient(180deg,transparent 54.17%,rgba(0,0,0,.7))}.swiper-button-next svg[data-v-7fc5609c],.swiper-button-prev svg[data-v-7fc5609c]{width:2.25rem;height:2.25rem}.swiper-button-next path[data-v-7fc5609c],.swiper-button-prev path[data-v-7fc5609c]{fill:#fff}", ""]);
// Exports
module.exports = exports;
